import { gql } from '@apollo/client'

import {
  PageInfoFieldsFragmentDoc,
  PopularProductsQueryVariables,
  ProductWithOfferFragmentDoc,
  SaleProductsQueryVariables,
} from '@shared/generated'

/*
  The generated variable types describe the codegen'd documents, which declare no
  $filter; the scoped documents below add it, so the pages type their variables
  with these instead.
*/
export type ScopedSaleProductsQueryVariables = SaleProductsQueryVariables & {
  filter?: Record<string, unknown>;
}

export type ScopedPopularProductsQueryVariables = PopularProductsQueryVariables & {
  filter?: Record<string, unknown>;
}

/*
  Filter-aware variants of the standard catalog list queries.

  The generated SaleProducts / PopularProducts documents declare no $filter, so
  a list reached from a scoped landing block ("Скидки" narrowed to a category)
  could not stay narrowed. These add that one argument and are otherwise
  identical, including pageInfo — the pages page through them the same way.

  Declared by hand rather than added to the .graphql sources because codegen
  needs schema introspection, which the deployed API disables. This mirrors what
  the landing block already does in landing-page-builder/model/productQueries.
*/

export const GQL_SCOPED_SALE_PRODUCTS = gql`
  query ScopedSaleProducts(
    $shopId: ID!
    $style: String
    $pager: CommonPagerInput
    $filter: NestedFilterInput
  ) {
    saleProducts(shop_id: $shopId, pager: $pager, filter: $filter) {
      edges {
        ...ProductWithOffer
      }
      pageInfo {
        ...PageInfoFields
      }
    }
  }
  ${ProductWithOfferFragmentDoc}
  ${PageInfoFieldsFragmentDoc}
`

export const GQL_SCOPED_POPULAR_PRODUCTS = gql`
  query ScopedPopularProducts(
    $shopId: ID!
    $style: String
    $pager: CommonPagerInput
    $filter: NestedFilterInput
  ) {
    popularProducts(shop_id: $shopId, pager: $pager, filter: $filter) {
      edges {
        ...ProductWithOffer
      }
      pageInfo {
        ...PageInfoFields
      }
    }
  }
  ${ProductWithOfferFragmentDoc}
  ${PageInfoFieldsFragmentDoc}
`
